<app-basic-page [pageTitle]="'Reports'">
  <h3>{{ startTime | toLocaleFormat: 'LLL dd' }} - {{ endTime | toLocaleFormat: 'LLL dd' }}</h3>
  <h3>Facts-based Objections & Questions (Score ≤ 3)</h3>
  <nz-table
    #topFailedFactsObjectionTable
    [nzData]="topFailedFactsBasedObjectionList()"
    [nzPaginationType]="'small'"
    [nzPageSize]="8"
  >
    <thead>
      <tr>
        <th>Objection or Question</th>
        <th>Sales</th>
        <th>Average Score</th>
        <th>Related Meetings</th>
      </tr>
    </thead>
    <tbody>
      @for (item of topFailedFactsObjectionTable.data; track item.objection.id; let i = $index) {
        <tr>
          <td>
            {{ item.objection.title }}
          </td>
          <td>
            @for (board of item.memberList; track board.id) {
              <app-board-icon [board]="board"></app-board-icon>
            }
          </td>
          <td [nzAlign]="'center'">
            {{ item.averageScore | number: '1.2-2' }}
          </td>
          <td>
            <div class="horizontal">
              @for (id of item.sessionIdList; track id) {
                <a
                  nz-button
                  nzType="link"
                  nzBlock
                  (click)="onSessionReportClick(id)"
                  [matTooltip]="'Open Simulated Meeting'"
                  ><span nz-icon style="font-size: 16px" class="material-symbols-rounded">open_in_new</span></a
                >
              }
            </div>
          </td>
        </tr>
      }
    </tbody>
  </nz-table>

  <h3>Soft-skills Objections & Questions (Score ≤ 3)</h3>
  <nz-table
    #topFailedEmotionalObjectionTable
    [nzData]="topFailedSoftSkillsObjectionList()"
    [nzPaginationType]="'small'"
    [nzPageSize]="8"
  >
    <thead>
      <tr>
        <th>Objection or Question</th>
        <th>Sales</th>
        <th>Average Score</th>
        <th>Related Meetings</th>
      </tr>
    </thead>
    <tbody>
      @for (item of topFailedEmotionalObjectionTable.data; track item.objection.id; let i = $index) {
        <tr>
          <td>
            {{ item.objection.title }}
          </td>
          <td>
            @for (board of item.memberList; track board.id) {
              <app-board-icon [board]="board"></app-board-icon>
            }
          </td>
          <td [nzAlign]="'center'">
            {{ item.averageScore | number: '1.2-2' }}
          </td>
          <td>
            <div class="horizontal">
              @for (id of item.sessionIdList; track id) {
                <a
                  nz-button
                  nzType="link"
                  nzBlock
                  (click)="onSessionReportClick(id)"
                  [matTooltip]="'Open Simulated Meeting'"
                  ><span nz-icon style="font-size: 16px" class="material-symbols-rounded">open_in_new</span></a
                >
              }
            </div>
          </td>
        </tr>
      }
    </tbody>
  </nz-table>
</app-basic-page>
